import { validateCPF } from 'validations-br';

class CPFValidatorAdapter {
  isValid (cpfNumber) {
    return validateCPF(cpfNumber);
  }
}

export default CPFValidatorAdapter;
